import type { MyConnections } from "@crux/contracts";
import { useQuery } from "@tanstack/react-query";
import { fetchMyConnections } from "../api/index.js";
import { queryKeys } from "../query-keys.js";

/** Every 3s while a new connection waits for its app (DESIGN.md "AI apps"). */
const WATCH_EVERY_MS = 3_000;

/**
 * Your own connections in every workspace, the workspaces you could reach and
 * the most you may give in each, and the MCP address. With `until`, it asks
 * again every few seconds until the answer satisfies it: "Waiting for Claude
 * Code to connect", or a new sign-in appearing.
 */
export function useMyConnections(
  enabled = true,
  until?: (mine: MyConnections) => boolean,
) {
  return useQuery({
    queryKey: queryKeys.connections(),
    queryFn: fetchMyConnections,
    enabled,
    refetchInterval: (query) => {
      if (until === undefined) return false;
      const mine = query.state.data;
      return mine !== undefined && until(mine) ? false : WATCH_EVERY_MS;
    },
  });
}
